import * as React from 'react'
import styled from '@emotion/styled'

import {NAV_BAR_MOBILE_HEIGHT, NavBar} from '@vio/atlas/NavBar'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {NavBarBackButton} from '@vio/shared/src/navBar'

type PropsType = {
  children?: React.ReactNode
  headerContent?: React.ReactNode
  onBackButtonClick: () => void
  endContent?: JSX.Element
  hideHeaderDivider?: boolean
  fullWidth?: boolean
}

const HeaderWrapper = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
`

const HeaderContentWrapper = styled(Text)`
  color: ${cssTheme.colors.content.neutral.primary};
  width: 100%;
`

const OverlaySection = styled.section<{fullWidth?: boolean}>`
  height: calc(100% - ${NAV_BAR_MOBILE_HEIGHT}px);
  display: flex;
  flex-direction: column;
  ${({fullWidth}) => fullWidth && 'width: 100%;'}
`

export const MobileOverlayLayout = ({
  children,
  headerContent,
  onBackButtonClick,
  endContent = null,
  hideHeaderDivider = false,
  fullWidth = false
}: PropsType) => {
  return (
    <>
      <HeaderWrapper>
        <NavBar
          centerAligned
          withDivider={!hideHeaderDivider}
          startContent={<NavBarBackButton onClick={onBackButtonClick} />}
          centerContent={
            <HeaderContentWrapper variant="titleM">
              {headerContent}
            </HeaderContentWrapper>
          }
          endContent={endContent}
        />
      </HeaderWrapper>
      <OverlaySection fullWidth={fullWidth}>{children}</OverlaySection>
    </>
  )
}
